import { VOLUNTEER_MIN_MEETINGS } from '@eforall/common';
import { DialogService, GridButton } from '@eforall/dashboard';
import { MentorSignUpAddDialog, MentorSignUpAddDialogData } from '../../../mentor-sign-up-add/mentor-sign-up-add.dialog';
import { VolunteerDialogDataService } from '../../volunteer-dialog-data.service';


export function getButtons(dialogService: DialogService, dialogDataService: VolunteerDialogDataService): GridButton[] {

	const buttons: GridButton[] = [];

	const addButton: GridButton = {
		iconClass: 'fa-plus',
		label: 'Add Mentor Sign-up',
		execute: async () => {

			const volunteerDetails = dialogDataService.volunteerDetails();
			const minSlotsRequired = VOLUNTEER_MIN_MEETINGS;

			if (!volunteerDetails?.mentorSchedule) {
				await dialogService.showMessage('Schedule Missing', 'Cannot add a Mentor Sign-up without an existing schedule', 'Okay', [], 300, 200);
				return;
			} else if (volunteerDetails.mentorSchedule.numMeetings < minSlotsRequired) {
				await dialogService.showMessage('Insufficient Meetings', `Cannot add a Mentor Sign-up with less than ${minSlotsRequired} meetings scheduled`, 'Okay', [], 300, 200);
				return;
			}


			const dialogData: MentorSignUpAddDialogData = {
				volunteerId: volunteerDetails.volunteerId,
				canVolunteerInEnglish: volunteerDetails.canVolunteerInEnglish,
				canVolunteerInSpanish: volunteerDetails.canVolunteerInSpanish
			};
			await dialogService.showCustom(MentorSignUpAddDialog, { data: dialogData }, 500, 300);
			await dialogDataService.reloadData();
		}
	};

	if (dialogDataService.canCoordinateVolunteers() && dialogDataService.volunteerDetails()?.isMentorApproved) {
		buttons.push(addButton);
	}

	return buttons;
}